import React, { useState, createContext, useContext, useEffect } from "react";
import api from "../../Utils/api";

const apiPath = {
  timesheets: "/timesheet/gettimesheetcount",
  jobs: "/jobnproject/getjobscount",
};

const nullFn = () => null;
const CountContext = createContext({
  loading: false,
  counts: {
    timesheets: null,
    jobs: null,
  },
  fetchCounts: nullFn,
});

export const useCountProvider = () => useContext(CountContext);
const CountProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [timesheets, setTimesheets] = useState(null);
  const [jobs, setJobs] = useState(null);

  useEffect(() => {
    fetchCounts();
  }, []);

  const fetchCounts = async () => {
    setLoading(true);
    try {
      const params = {
        userId: localStorage.getItem("userId"),
        userType: "CONSULTANT",
      };

      const timesheetRes = await api.get(apiPath.timesheets, { params });
      const jobRes = await api.get(apiPath.jobs, { params });

      if (timesheetRes.data?.success) {
        setTimesheets(
          timesheetRes.data.result.approved + timesheetRes.data.result.pending
        );
      }

      if (jobRes.data?.success) setJobs(jobRes.data.result);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const value = {
    loading,
    counts: { timesheets, jobs },
    fetchCounts,
  };

  return (
    <CountContext.Provider value={value}>{children}</CountContext.Provider>
  );
};

export default CountProvider;
